<template>
  <div class="tab-content">
    <div class="progress-line">
      <div class="done" :style="`width: ${14.28 * activeTab}%`"></div>
    </div>

    <div v-if="activeTab === STEPS.NAME_STEP">
      <name-step @save="save" :loading="loading" :campaign="campaign" />
    </div>
    <div v-if="activeTab === STEPS.TYPE_STEP">
      <type-step @save="save" :loading="loading" :campaign="campaign" />
    </div>
    <div v-if="activeTab === STEPS.SEGMENTATION_STEP">
      <segmentation-step @save="save" :loading="loading" :campaign="campaign" />
    </div>
    <div v-if="activeTab === STEPS.COUPON_STEP">
      <coupon-step @save="save" :loading="loading" :campaign="campaign" />
    </div>
    <div v-if="activeTab === STEPS.DELIVERY_STEP">
      <delivery-step @save="save" :loading="loading" :campaign="campaign" />
    </div>
    <div v-if="activeTab === STEPS.TEXT_STEP">
      <message-step @save="save" :loading="loading" :campaign="campaign" />
    </div>
    <div v-if="activeTab === STEPS.TIME_STEP">
      <time-step @save="save" :loading="loading" :campaign="campaign" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import NameStep from '@/containers/Performance/Steps/NameStep';
import TypeStep from '@/containers/Performance/Steps/TypeStep';
import SegmentationStep from '@/containers/Performance/Steps/SegmentationStep';
import CouponStep from '@/containers/Performance/Steps/CouponStep';
import DeliveryStep from '@/containers/Performance/Steps/DeliveryStep';
import MessageStep from '@/containers/Performance/Steps/MessageStep';
import TimeStep from '@/containers/Performance/Steps/TimeStep';

const STEPS = {
  NAME_STEP: 1,
  TYPE_STEP: 2,
  SEGMENTATION_STEP: 3,
  COUPON_STEP: 4,
  DELIVERY_STEP: 5,
  TEXT_STEP: 6,
  TIME_STEP: 7,
};

const components = {
  NameStep,
  TypeStep,
  SegmentationStep,
  CouponStep,
  DeliveryStep,
  MessageStep,
  TimeStep,
};

export default {
  components,
  props: {
    activeTab: { type: Number, default: 1 },
    loading: { type: Boolean, default: false },
    campaign: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      STEPS,
    };
  },
  methods: {
    save(campaign) {
      this.$emit('save', campaign);
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
    }),
  },
};
</script>

<style></style>
